import { render, staticRenderFns } from "./MyInfoDropDownMenuItem.vue?vue&type=template&id=22051252&"
import script from "./MyInfoDropDownMenuItem.vue?vue&type=script&lang=js&"
export * from "./MyInfoDropDownMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22051252')) {
      api.createRecord('22051252', component.options)
    } else {
      api.reload('22051252', component.options)
    }
    module.hot.accept("./MyInfoDropDownMenuItem.vue?vue&type=template&id=22051252&", function () {
      api.rerender('22051252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/menu/MyInfoDropDownMenuItem.vue"
export default component.exports